// extracted by mini-css-extract-plugin
export default {"textArea":"WordListTextArea-textArea-8fff59b7c82ac324d86e6e9ffd125776"};